import Input from './Input'
import Textarea from './Textarea'
import RightBarGroup from './RightBarGroup'
import { Button } from '@bm-js/atlascloud-ui'
import Select from './Select'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  VideoHeroData,
} from '@bm-js/atlascloud-shared'
import { useMedia } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const overlayOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]

type Props = {
  content: DynamicContentType<VideoHeroData>
  setData: (e: ChangeEvent<string | FileEntryBM>) => void
}

const VideoHeroEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  const { openMediaSelector, closeMediaSelector } = useMedia()

  return (
    <>
      <RightBarGroup title={tr(TrKey.videoHeroEditorContentTitle)}>
        <Input
          light
          label={tr(TrKey.videoHeroEditorHeaderTextLabel)}
          desc={tr(TrKey.videoHeroEditorHeaderTextDescription)}
          placeholder={tr(TrKey.videoHeroEditorHeaderTextPlaceholder)}
          type='text'
          name='headerText'
          id='headerText'
          value={content.data.headerText}
          onChange={setData}
        />
        <Textarea
          light
          label={tr(TrKey.videoHeroEditorParagraphTextLabel)}
          desc={tr(TrKey.videoHeroEditorParagraphTextDescription)}
          placeholder={tr(TrKey.videoHeroEditorParagraphTextPlaceholder)}
          name='paragraphText'
          id='paragraphText'
          value={content.data.paragraphText}
          onChange={setData}
        />
        <Input
          light
          label={tr(TrKey.videoHeroEditorCtaTextLabel)}
          desc={tr(TrKey.videoHeroEditorCtaTextDescription)}
          placeholder={tr(TrKey.videoHeroEditorCtaTextPlaceholder)}
          type='text'
          name='ctaText'
          id='ctaText'
          value={content.data.ctaText}
          onChange={setData}
        />
        <Input
          light
          label={tr(TrKey.videoHeroEditorCtaLinkLabel)}
          desc={tr(TrKey.videoHeroEditorCtaLinkDescription)}
          placeholder={tr(TrKey.videoHeroEditorCtaLinkPlaceholder)}
          type='text'
          name='ctaLink'
          id='ctaLink'
          value={content.data.ctaLink}
          onChange={setData}
        />
        <Select
          light
          label={tr(TrKey.videoHeroEditorOverlayPercentageLabel)}
          desc={tr(TrKey.videoHeroEditorOverlayPercentageDescription)}
          onChange={setData}
          name='overlayPercentage'
          id='overlayPercentage'
          value={content.data.overlayPercentage}
        >
          <option value={0}>
            {tr(TrKey.videoHeroEditorOverlayPercentageOptionNone)}
          </option>
          {overlayOptions.map((o) => (
            <option key={`videoHeroOverlayOption_${o}`} value={o}>
              {o}%
            </option>
          ))}
        </Select>
      </RightBarGroup>
      <RightBarGroup title={tr(TrKey.videoHeroEditorVideoTitle)}>
        <p className='label light mb-2'>
          {content.data.file?.name || tr(TrKey.videoHeroEditorNoVideoSelected)}
        </p>
        <Button
          onClick={() =>
            openMediaSelector({
              fileType: 'video',
              onSelect: (f) => {
                if (!f) return closeMediaSelector()
                const e = {
                  target: {
                    name: 'file',
                    value: f,
                  },
                }
                setData(e)
                closeMediaSelector()
              },
            })
          }
        >
          {content.data.file?.name
            ? tr(TrKey.videoHeroEditorChangeVideo)
            : tr(TrKey.videoHeroEditorSelectVideo)}
        </Button>
      </RightBarGroup>
    </>
  )
}

export default VideoHeroEditor
